import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/index.js
// module id = 798
// module chunks = 0